<template>
  <div class="font-bold filter facet">
    <div v-if="!isOpen" @click="isOpen=true"
         class=" flex flex-col cursor-pointer mt-2 flex-wrap w-full align-center  justify-evenly h-1/10">
      <div class="burger p-1 flex items-center self-center justify-center">
        <img src="../../../assets/icons/filter.svg" class="transform rotate-180"/>
      </div>
      <p class="transform -rotate-90 flex mt-2 text-right items-center justify-center">
        {{ getTranslation('filter') }}
      </p>
    </div>

    <div v-if="isOpen" class="flex flex-row-reverse pl-6 pt-4 flex-row">
      <div class="burger cursor-pointer w-1/10 flex items-center justify-center"
           @click="isOpen=false">
        <font-awesome-icon icon="angle-left"/>
      </div>
      <div class="w-9/10 pb-8">
        <div class="flex justify-items-start mb-5">
          <button class="classen__button hover__button mr-3"
                  :class="{'classen__button_active': menuItem===0}"
                  @click="menuItem=0">
            {{ getTranslation('boxes') }}
          </button>
          <button class="classen__button hover__button"
                  :class="{'classen__button_active': menuItem===1}"
                  @click="menuItem=1">
            {{ getTranslation('inlays') }}
          </button>
        </div>

        <div class="grid grid-cols-2 gap-1">
          <p class="text-left">{{
              (activeTab === 0) ? getTranslation("boxId") : getTranslation("inlayId")
            }}</p>
          <c-input v-if="activeTab===0" :idkey="0" v-model="queryData.query.boxId"
                   :name="'boxId'"></c-input>

          <c-input v-if="activeTab===1" :idkey="0" v-model="queryData.query.inlayId"
                   :name="'inlayId'"></c-input>

          <p class="text-left">{{ getTranslation("name") }}</p>
          <c-input :idkey="0" v-model="queryData.query.name"
                   :name="'name'"></c-input>

          <p class="text-left">{{ getTranslation("articleNumber") }}</p>
          <c-input :idkey="0" v-model="numbersCopy"
                   :name="'articleName'"></c-input>
        </div>
        <div class="grid grid-rows-1 mt-8">
          <button @click="$emit('reload-facets')"
                  class="classen__button hover__button justify-self-end">
            <p class="leading-none">{{ getTranslation('reset') }}</p>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Input from "../../form/Input";
import DropDownFacet from "../DropDownFacet";
import CustomCheckbox from "../../form/CustomCheckbox";
import Button from "../../Button";
import getTranslation from "../../../mixins/getTranslation";

export default {
  name: "PackageFacets",

  components: {
    Button,
    'c-checkbox': CustomCheckbox,
    'c-input': Input,
    'c-facet-dropdown': DropDownFacet
  },

  props: {
    opened: {required: true, type: Boolean},
    onlyNew: {required: true, type: Boolean},
    queryData: {required: false},
    activeTab: {required: true},
    numbers: {required: true},
  },

  mixins: [getTranslation],

  watch: {
    isOpen() {
      this.$emit('update:opened', this.isOpen);
    },

    onlyNewItems() {
      this.$emit('update:onlyNew', this.onlyNewItems);
    },

    menuItem() {
      this.$emit('update:activeTab', this.menuItem)
    },

    numbersCopy() {
      this.$emit('update:numbers', this.numbersCopy)
    },
  },

  created() {
  },

  data() {
    return {
      dropDownVisible: '',
      onlyNewItems: this.onlyNew,
      isOpen: this.opened,
      menuItem: this.activeTab,
      numbersCopy: this.numbers,
    }
  },
}
</script>
<style scoped>
.burger {
  height: 30px;
  width: 30px;
  color: white;
  margin-left: auto;
  margin-right: auto;
  border-radius: 50%;
  background-color: #80695A;
}

.facet {
  box-shadow: 0 0 0 2px rgba(241, 241, 241, 1);
  -webkit-box-shadow: 0 0 0 2px rgba(241, 241, 241, 1);
  -moz-box-shadow: 0 0 0 2px rgba(241, 241, 241, 1);
  border-radius: 0 0 50px 0;
}
</style>
